/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Createnewpatientprompt3Inputs */

const en_questionnaire_createnewpatientprompt3 = /** @type {(inputs: Questionnaire_Createnewpatientprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please create a new patient to start a questionnaire.`)
};

const fr_questionnaire_createnewpatientprompt3 = /** @type {(inputs: Questionnaire_Createnewpatientprompt3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez créer un nouveau patient pour commencer un questionnaire.`)
};

/**
* | output |
* | --- |
* | "Please create a new patient to start a questionnaire." |
*
* @param {Questionnaire_Createnewpatientprompt3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_createnewpatientprompt3 = /** @type {((inputs?: Questionnaire_Createnewpatientprompt3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Createnewpatientprompt3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_createnewpatientprompt3(inputs)
	return fr_questionnaire_createnewpatientprompt3(inputs)
});
export { questionnaire_createnewpatientprompt3 as "questionnaire_createNewPatientPrompt" }